'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'triangle-exclamation';
var width = 512;
var height = 512;
var aliases = [9888,"exclamation-triangle","warning"];
var unicode = 'f071';
var svgPathData = ['M20.8 429.4c-3.7 6.9-3.6 15.3 .5 22.1s11.3 10.9 19.2 10.9l432 0c7.9 0 15.2-4.2 19.2-10.9s4.2-15.2 .5-22.1l-216-400c-3.4-6.3-9.6-10.6-16.7-11.6l-3-.2c-7 0-13.6 3.3-17.8 8.8l-2.1 3.3-215.8 399.6zM272.5 392a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM242.4 182.7c-.3-8 6.1-14.7 14.1-14.7l2.9 .3c6.6 1.4 11.5 7.4 11.2 14.4l-6.1 145.6c-.2 4.3-3.7 7.6-8 7.7-4.3 0-7.8-3.4-8-7.7l-6.1-145.6z', 'M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.6 480 472.5 480l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400 2.9-4.6C231.7 6.2 243.7 0 256.5 0zm0 17.6c-7 0-13.6 3.3-17.8 8.8l-2.1 3.3-215.8 399.6c-3.7 6.9-3.6 15.3 .5 22.1s11.3 10.9 19.2 10.9l432 0c7.9 0 15.2-4.2 19.2-10.9s4.2-15.2 .5-22.1l-216-400c-3.4-6.3-9.6-10.6-16.7-11.6l-3-.2zm0 390.4a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm2.9-239.7c6.6 1.4 11.5 7.4 11.2 14.4l-6.1 145.6c-.2 4.3-3.7 7.6-8 7.7-4.3 0-7.8-3.4-8-7.7l-6.1-145.6c-.3-8 6.1-14.7 14.1-14.7l2.9 .3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTriangleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;